import React from "react";
import { useHistory, useLocation } from "react-router-dom";

export default function NewsMediaCategories() {
	const history = useHistory()
    const location = useLocation()

    return (
        <ul className="topbar-category-media-section">
            <li
                className="media-type row"
                onClick={() => history.push("/portal/news/tv-media-data")}
				style={{ opacity: `${location.pathname === '/portal/news/tv-media-data' ? 0.5 : 1}` }}
			>
                <div className="col-md-3 ms-3 d-flex justify-content-center">
                    <img
                        src={
                            window.location.origin +
                            "/assets/images/dataservice/news-tv.png"
                        }
                        alt="TV Media"
                        className="img-fluid media-category-icon"
                    />
                </div>
                <div className="col-md-9">
                    <div className="media-category-label">TV Media</div>
                    <div style={{ color: "grey" }}>News Data</div>
                </div>
            </li>
            <li
                className="media-type row"
                onClick={() => history.push("/portal/news/print-media-data")}
				style={{ opacity: `${location.pathname === '/portal/news/print-media-data' ? 0.5 : 1}` }}
			>
                <div className="col-md-3 ms-3 d-flex justify-content-center">
                    <img
                        src={
                            window.location.origin +
                            "/assets/images/dataservice/news-print.png"
                        }
                        alt="Print Media"
                        className="img-fluid media-category-icon"
                    />
                </div>
                <div className="col-md-9">
                    <div className="media-category-label">Print Media</div>
                    <div style={{ color: "grey" }}>News Data</div>
                </div>
            </li>
            <li
                className="media-type row"
                onClick={() => history.push("/portal/news/online-media-data")}
				style={{ opacity: `${location.pathname === '/portal/news/online-media-data' ? 0.5 : 1}` }}
			>
                <div className="col-md-3 ms-3 d-flex justify-content-center">
                    <img
                        src={
                            window.location.origin +
                            "/assets/images/dataservice/news-online.png"
                        }
                        alt="Online Media"
                        className="img-fluid media-category-icon"
                    />
                </div>
                <div className="col-md-9">
                    <div className="media-category-label">Online Media</div>
                    <div style={{ color: "grey" }}>News Data</div>
                </div>
            </li>
            <li
                className="media-type row"
                onClick={() => history.push("/portal/news/digital-media-data")}
				style={{ opacity: `${location.pathname === '/portal/news/digital-media-data' ? 0.5 : 1}` }}
			>
                <div className="col-md-3 ms-3 d-flex justify-content-center">
                    <img
                        src={
                            window.location.origin +
                            "/assets/images/dataservice/news-radio.png"
                        }
                        alt="Digital Media"
                        className="img-fluid media-category-icon"
                    />
                </div>
                <div className="col-md-9">
                    <div className="media-category-label">Social Media</div>
                    <div style={{ color: "grey" }}>News Data</div>
                </div>
            </li>
        </ul>
    );
}
